import { Task } from "./task.model";
import { Observable } from "rxjs/Observable";
import { Qry } from "../query-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import * as actions from "./task.actions";
import { Job } from "../job/job.model";
import { AccountObjectStoreFacade } from "../account-object/account-object.store-facade";
import { VasState } from "../../store/store-type";
import { ITaskFilters } from "./task.reducer";
import { TaskType } from "../task-type/task-type.model";

export class TaskStoreFacade extends AccountObjectStoreFacade<Task> {

    getAll(): Observable<Array<Task>> {
        return this.select(Qry.getInstance().task.byActiveAccount);
    }

    getFiltered(): Observable<Array<Task>> {
        return this.select(Qry.getInstance().task.filtered);
    }

    create(jobTask: Task): void {
        this.dispatch(new actions.SubmitAction(jobTask));
    }

    update(jobTask: Task): void {
        this.dispatch(new actions.SubmitAction(jobTask));
    }

    insert(jobTask: Task): void {
        this.dispatch(new actions.SubmitAction(jobTask, {persistable: true, restful: false}));
    }

    remove(jobTask: Task, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(jobTask, options));
    }

    removeByTaskType(taskType: TaskType, options?: ActionOptionsArgs): void {
        this.removeBy(task => task.taskType === taskType.id, options);
    }

    getByJob(job: Job): Observable<Array<Task>> {
        return this.getBy(task => task.job === job.id);
    }

    setFilters(filters: ITaskFilters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }

    setTotal(total: number): void {
        this.dispatch(new actions.SetTotalAction(total));
    }

    getTotal(): Observable<number> {
        return this.select((state: VasState) => state.task.total);
    }

    loadNextPage(): void {
        return this.dispatch(new actions.LoadNextPage());
    }

    canLoadMore(): Observable<boolean> {
        return this.select((state: VasState) => state.task.total !== state.task.ids.length);
    }

    getFilters(): Observable<ITaskFilters> {
        return this.select((state: VasState) => {
            return state.task.filters;
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.store-facade.ts